import classNames from 'classnames';
import React from 'react';

import styles from './styles/button_custom.module.scss';

// variants: primary | outlined

export const ButtonCustom = ({
  text,
  className,
  variant = 'primary',
  ...props
}) => {
  const buttonClassNames = classNames({
    [styles.button]: true,
    [styles[`button--${variant}`]]: true,
    [className]: Boolean(className),
  });

  return (
    <button className={buttonClassNames} {...props}>
      {text}
    </button>
  );
};
